'use client'

import { useState, useEffect } from 'react'
import axios from '@/utils/axiosInterceptor'

import styles from './Calendar.module.scss'
import classNames from 'classnames/bind'
import Badge from '../Badge/Badge'
const classes = classNames.bind(styles)

export default function Calendar({}) {
    const [events, setEvents] = useState({
        January: [],
        February: [],
        March: [],
        April: [],
        May: [],
        June: [],
        July: [],
        August: [],
        September: [],
        October: [],
        November: [],
        December: [],
    })

    const year = 2025

    useEffect(() => {
        const fetchEvents = async () => {
            const {
                data: { data: events },
            } = await axios.get(`/assessment/api/dashboard/events`)
            setEvents(events)
        }

        fetchEvents()
    }, [])

    const date = new Date()
    const currentMonth = date.getMonth()

    let eventCount = 0

    return (
        <div className={classes('container')}>
            <div className={classes('header')}>
                <h5>Personal Tax dates</h5>
                <Badge text={year} color="gray" />
            </div>

            <div className={classes('calendar')}>
                {Object.keys(events).map((month, i) => (
                    <div
                        key={month}
                        className={classes('month-cell', { current: currentMonth == i, past: currentMonth > i })}
                    >
                        <span className={classes('month')}>
                            {month.slice(0, 3)}
                            {events[month].length > 0 && <div className={classes('dot')}></div>}
                        </span>
                    </div>
                ))}
            </div>

            <div className={classes('event-list')}>
                {Object.entries(events).map(([month, events], monthIndex) => {
                    if (currentMonth > monthIndex) return null
                    const isCurrentMonth = currentMonth == monthIndex
                    return events
                        .sort(({ date: dateA }, { date: dateB }) => dateA - dateB)
                        .map((event, i) => {
                            if (eventCount > 2) return null
                            eventCount++
                            return (
                                <EventDetails
                                    key={`${monthIndex}-${i}`}
                                    event={event}
                                    month={month}
                                    currentMonth={isCurrentMonth}
                                />
                            )
                        })
                })}
            </div>
        </div>
    )
}

const EventDetails = ({ event, month, currentMonth }) => {
    return (
        <div className={classes('event-details')}>
            <div className={classes('event-header')}>
                <span className={classes('title')}>{event.name}</span>
                <span className={classes('date', { upcoming: currentMonth })}>{`${event.date} ${month} 2025`}</span>
            </div>
            <p className={classes('description')}>{event.description}</p>
        </div>
    )
}
